// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PriceFormatter } from '@shared/utils/Instruments/PriceFormatter';
import { MathUtils } from '@shared/utils/MathUtils';
import { StringUtils } from '@shared/utils/StringUtils';
class _GreeksFormatter {
    constructor() {
        this.NOT_AVAILABLE = StringUtils.THREE_DASHES;
        this.INFINITY = '∞';
        this.GREEKS_PERCISION = 4;
        this.IV_PERCISION = 3;
    }
    roundGreek(greek) {
        if (isNaN(greek)) {
            return NaN;
        }
        const precision = MathUtils.GetValuePrecision(greek, 2, this.GREEKS_PERCISION);
        return MathUtils.Round(greek, precision);
    }
    roundIV(iv) {
        if (isNaN(iv)) {
            return NaN;
        }
        return MathUtils.Round(iv, this.IV_PERCISION);
    }
    formatGreek(greek, precision = undefined, withourZeroes = false) {
        if (isNaN(greek) || greek === 0) {
            return this.NOT_AVAILABLE;
        }
        const formatPrecision = isValidNumber(precision)
            ? precision
            : MathUtils.GetValuePrecision(greek, 2, this.GREEKS_PERCISION);
        return this.formatValue(greek, formatPrecision, withourZeroes);
    }
    formatIV(iv, precision = undefined, withourZeroes = false) {
        if (isNaN(iv) || iv === 0) {
            return this.NOT_AVAILABLE;
        }
        if (!isFinite(iv)) {
            return this.INFINITY;
        }
        const formatPrecision = isValidNumber(precision) ? precision : this.IV_PERCISION;
        const formattedValue = this.formatValue(iv, formatPrecision, withourZeroes);
        return `${formattedValue} %`;
    }
    formatValue(value, precision, withourZeroes) {
        const roundedValue = MathUtils.Round(value, precision);
        return withourZeroes
            ? PriceFormatter.formatPriceWithoutZeroes(roundedValue, precision)
            : PriceFormatter.formatPrice(roundedValue, precision);
    }
}
export const GreeksFormatter = new _GreeksFormatter();
